import { React, useEffect, useState } from 'react';
import { loginPageStyles } from '../../../../../styles';
import { TextField, Box } from '@mui/material';
import ChangePasswordPopVew from './ChangePasswordPopup.js';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/;

const ChangePassword = ({ invitation_token }) => {
  const classes = loginPageStyles();
  const [passwords, setPasswords] = useState({
    newPassword: '',
    confirmedPassword: '',
  });
  const rider = useSelector((state) => state.userReducer.rider);
  const [format, setFormat] = useState(true);
  const [equal, setEqual] = useState();
  const [lengthValidation, setLengthValidation] = useState();

  const onNewPasswordChangeHandler = (e) => {
    setPasswords({ ...passwords, newPassword: e.target.value });
  };
  const onConfirmPasswordChangeHandler = (e) => {
    setPasswords({ ...passwords, confirmedPassword: e.target.value });
  };

  useEffect(() => {
    if (passwords.newPassword?.length >= 8) {
      setLengthValidation(true);
    } else {
      setLengthValidation(false);
    }
    if (PASSWORD_REGEX.test(passwords.newPassword)) {
      setFormat(true);
    } else {
      setFormat(false);
    }
    if (passwords.confirmedPassword === passwords.newPassword) {
      setEqual(true);
    } else {
      setEqual(false);
    }
  }, [passwords]);

  const titleStyle = {
    fontFamily: 'Mukta',
    fontSize: '24px',
    lineHeight: '31px',
    fontWeight: '700',
    letterSpacing: '-0.01em',
    color: '#111111',
  };

  const textStyle = {
    fontFamily: 'Mulish',
    fontSize: '13px',
    lineHeight: '16px',
  };

  return (
    <>
      <Box sx={{ mb: '10px' }} className={classes.heading10} style={titleStyle}>
        {invitation_token ? 'Create' : 'Change'} Password
      </Box>
      <Box sx={{ maxWidth: '323px', width: '100%' }}>
        <Box
          className={classes.heading}
          sx={{
            mb: '20px',
            fontSize: '15px',
            lineHeight: '19px',
            color: '#111111',
            textAlign: 'center',
          }}
        >
          Enter the password you want to set for your account
        </Box>
        <Box sx={{ maxWidth: '323px' }}>
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ mb: '4px', color: '#455066' }} style={textStyle}>
              New Password
            </Box>
            <TextField
              size="small"
              fullWidth
              error={lengthValidation && !format ? true : false}
              autoComplete="off"
              helperText={
                !format && lengthValidation
                  ? 'The password must be atleast 8 characters and should contain atleast one alphabet, one digit and one special character'
                  : ''
              }
              className={classes.textField}
              type="password"
              value={passwords.newPassword}
              name="newPassword"
              onChange={(e) => onNewPasswordChangeHandler(e)}
              variant="outlined"
              placeholder="New Password"
              inputProps={{ minLength: 8 }}
            />
          </Box>
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ mb: '4px', color: '#455066' }} style={textStyle}>
              Confirm Password
            </Box>{' '}
            <TextField
              fullWidth
              disabled={!format}
              error={
                passwords.confirmedPassword.length >=
                  passwords.newPassword.length && !equal
              }
              helperText={
                passwords.confirmedPassword.length >=
                  passwords.newPassword.length && !equal
                  ? 'Passwords must match'
                  : ''
              }
              autoComplete="off"
              className={classes.textField}
              type="password"
              value={passwords.confirmedPassword}
              name="confirmPassword"
              onChange={(e) => onConfirmPasswordChangeHandler(e)}
              variant="outlined"
              placeholder="Confirm Password"
              inputProps={{ minLength: 8 }}
            />
          </Box>
        </Box>
      </Box>
      <ChangePasswordPopVew
        user={rider?.id}
        passwordValidation={lengthValidation && format && equal}
        invitation_token={invitation_token}
        passwords={passwords}
      />
    </>
  );
};
ChangePassword.propTypes = {
  invitation_token: PropTypes.string.isRequired,
};
export default ChangePassword;
